export default "__VITE_ASSET__BOI$G1u3__"